<template>
    <div class="edit-footer">
        <div class="footer-actions td-flex">
            <p class="mb-0 mt-1" v-if="locationAdminInfo.verifiedDate">
                <strong> Last verified on:</strong>
                {{locationAdminInfo.verifiedDate}}
                <span v-if="locationAdminInfo.verifiedByName" class="mr-1"> by {{locationAdminInfo.verifiedByName}}</span>
                <button class="td-btn success verify-btn icon-left" @click="verifyListing"><icon name="faCheck" type="solid"></icon>Verify</button>
            </p>
            <div v-if="isAdmin" class="admin-info td-flex">
                <p class="my-1" v-if="locationAdminInfo.ratingValue >= 0"><strong>Rating value: </strong> {{locationAdminInfo.ratingValue}}</p><span class="hide-mobile">|</span>
                <p class="my-1" v-if="locationAdminInfo.createdDate"><strong>Created:</strong> {{locationAdminInfo.createdDate}}</p><span class="hide-mobile">|</span>
                <p class="my-1" v-if="locationAdminInfo.modifiedDate"><strong>Modified:</strong> {{locationAdminInfo.modifiedDate}}</p>
            </div>
        </div>
    </div>

</template>

<script>
    import script from './EditFooter';
    export default script;</script>